<template>
	<div class="dialogContent jobModule">
		<el-container>
      <div class="details-parameter-tit myDetail" v-if="this.source !== 1">
        <span v-if="njInfoData.njInfo&&njInfoData.njInfo">{{njInfoData.njInfo.itemName}}详情</span>
      </div>
			<div class="details-parameter-tit myDetail" v-else>
				<span v-if="details.njInfo&&details.njInfo">{{details.njInfo.titleName}}详情</span>
			</div>
      <div class="details-parameter" v-if="this.source !== 1">
        <div class="details-parameter-left">
          <div class="parameter-njxx">
            <img src="../../../static/img/njxx-icon.png" alt="">
            <span style="color: #fff;">农机信息</span>
          </div>
          <table class="parameter-table" v-if="njInfoData.njInfo">
            <tr>
              <td style="text-align: left;">农机名称</td>
              <td style="">{{njInfoData.njInfo.njName}}</td>
              <td style="width: 20%">出厂编号</td>
              <td>{{njInfoData.njInfo.factoryCode}}</td>
              <td width="20%">机主</td>
              <td style="max-width:10px;" v-bind:title="njInfoData.njInfo.driverName">{{njInfoData.njInfo.driverName}}</td>
            </tr>
            <tr>
              <td style="">生产企业</td>
              <td>{{njInfoData.njInfo.factoryName}}</td>
              <td>监控编号</td>
              <td>{{njInfoData.njInfo.imei}}</td>
              <td >补贴金额</td>
              <td style="min-width: 80px" v-if="njInfoData.njInfo.totalSubsidy!=='-'">{{njInfoData.njInfo.totalSubsidy}}元</td>
              <td style="min-width: 80px" v-else>{{njInfoData.njInfo.totalSubsidy}}</td>
            </tr>
            <tr>
              <td style="text-align: center;padding: 0 0 0 5px;">经销商</td>
              <td>{{njInfoData.njInfo.dealerName}}</td>
              <td style="">补贴进度</td>
              <td>{{njInfoData.njInfo.isSubsidy}}</td>
              <td >补贴地址</td>
              <td v-bind:title="njInfoData.njInfo.subsidyAddr">{{njInfoData.njInfo.subsidyAddr}}</td>
            </tr>
          </table>
          <div v-else style="text-align: center;line-height: 60px;margin-top:30px;font-size: 34px;color:#999;display: inline-block">暂无数据</div>
          <div class="details-parameter-ewm">
            <p style="color: #75c3ff;margin-bottom: 0.5vw;font-size: 0.83vw;">农机身份二维码</p>
            <div class="" v-if="njInfoData.njInfo&&njInfoData.njInfo.qrCode !=='-'">
              <img :src="njInfoData.njInfo.qrCode" style="width:5vw;height:9vh;">
            </div>
          </div>
        </div>
        <div class="details-parameter-right">
          <p style="margin: 20px 0 0 35px;color: #fff;">运行信息</p>
          <table class="details-running" v-if="njInfoData&&njInfoData.njInfo" style="position: relative">
            <tr >
              <td >总时长</td>
              <td>{{njInfoData.runInfo.sumRunHour==null?'--':njInfoData.runInfo.sumRunHour}}小时</td>
              <td>总里程</td>
              <td>{{njInfoData.runInfo.sumMileage==null?'--':njInfoData.runInfo.sumMileage}}公里</td>
              <td>总面积</td>
              <td>{{njInfoData.runInfo.sumArea==null?'--':njInfoData.runInfo.sumArea}}亩</td>
            </tr>
            <!-- <div style="position: absolute;left: 5px;top:40px">
              <div v-if="njInfoData.isWorkToday==1"><el-button type="primary" @click="tadayRecord()">今日作业</el-button></div>
              <div v-else style="color: #eee"><el-button type="info">今日作业</el-button></div>
            </div> -->
          </table>
          <div v-else style="text-align: center;line-height: 70px;font-size: 34px;color:#999">暂无数据</div>
        </div>
      </div>
			<div class="details-parameter" v-else>
				<div class="details-parameter-left">
					<div class="parameter-njxx">
						<img src="../../../static/img/njxx-icon.png" alt="">
						<span style="color: #fff;">农机信息</span>
					</div>
					<table class="parameter-table" v-if="details.njInfo">
						<tr>
							<td style="text-align: left;">农机名称</td>
							<td style="">{{details.njInfo.nj_name}}</td>
							<td style="width: 20%">出厂编号</td>
							<td>{{details.njInfo.factory_code}}</td>
							<td width="20%">机主</td>
							<td style="max-width:10px;" v-bind:title="details.njInfo.name">{{details.njInfo.name}}</td>
						</tr>
						<tr>
							<td style="">生产企业</td>
							<td>{{details.njInfo.factory_name}}</td>
							<td>监控编号</td>
							<td>{{details.njInfo.imei}}</td>
							<td>补贴金额</td>
							<td style="min-width: 80px" v-if="details.njInfo.total_subsidy==0?'--':details.njInfo.total_subsidy">{{details.njInfo.total_subsidy}}元</td>
						</tr>
						<tr>
							<td style="text-align: center;padding: 0 0 0 5px;">经销商</td>
							<td>{{details.njInfo.dealer_name}}</td>
							<td style="">农机性质</td>
							<td>{{details.njInfo.is_subsidy}}</td>
							<td>补贴地址</td>
							<td v-bind:title="details.njInfo.subAddress">{{details.njInfo.subAddress}}</td>
						</tr>
					</table>
					<div v-else style="text-align: center;line-height: 60px;margin-top:30px;font-size: 44px;color:#999;display: inline-block">暂无数据</div>
					<div class="details-parameter-ewm" v-if="details.njInfo.qr_code">
						<p style="color: #75c3ff;margin-bottom: 0.5vw;font-size: 0.83vw;">农机身份二维码</p>
						<div class="">
							<img :src="details.njInfo.qr_code" style="width:5.5vw;height:9vh;">
						</div>
					</div>
				</div>
				<div class="details-parameter-right">
					<!--<img src="../../../static/img/details_bg2.png" alt="" width="700px" height="175px">-->
					<p style="margin: 20px 0 0 35px;color: #fff;">运行信息</p>
					<table class="details-running" v-if="details&&details.njInfo" style="position: relative">
						<tr>
							<td>总时长</td>
							<td>{{details.njRunInfo.sumRunHour==null?'--':details.njRunInfo.sumRunHour}}小时</td>
							<td>总里程</td>
							<td>{{details.njRunInfo.sumMileage==null?'--':details.njRunInfo.sumMileage}}公里</td>
							<td>总面积</td>
							<td>{{details.njRunInfo.sumArea==null?'--':details.njRunInfo.sumArea}}亩</td>
							<!--<td v-if="this.details.isWorkToday==1" > <el-button type="primary"><router-link :to="{name:'TodayRecordItem',params:{imei:details.listNjInfo[0].imei,startTime:details.startTime,flag:'today'}}"  style="color: #fff;text-decoration: none">今日作业</router-link></el-button></td>-->
							<!--<td>当前状态</td>-->
							<!--<td>{{details.listRunInfo[0].status==0?'&#45;&#45;':details.listRunInfo[0].status}}</td>-->
						</tr>
						<!--<div style="position: absolute;left: 10px;top:40px">
							<div v-if="details.isWorkToday==1">
								<el-button type="primary" @click="tadayRecord()">今日作业</el-button>
							</div>
							<div v-else style="color: #eee">
								<el-button type="info">今日作业</el-button>
							</div>
						</div>-->
						<!--<tr>-->
						<!--<td v-if="this.details.isWorkToday==1" >今日作业-->
						<!--<td @click="trajectory(scope.row)">今日作业</td>-->
						<!--<td>今日时长</td>-->
						<!--<td>{{details.listRunInfo[0].stat_time==0?'&#45;&#45;':details.listRunInfo[0].stat_time}}小时</td>-->
						<!--<td>今日里程</td>-->
						<!--<td>{{details.listRunInfo[0].mileage==0?'&#45;&#45;':details.listRunInfo[0].mileage}}公里</td>-->
						<!--<td>今日面积</td>-->
						<!--<td>{{details.listRunInfo[0].area_day==null?'计算中':details.listRunInfo[0].area_day+'亩'}}</td>-->
						<!--<td>速度</td>-->
						<!--<td>{{details.listRunInfo[0].speed==0?'&#45;&#45;':details.listRunInfo[0].speed}}km/h</td>-->
						<!--</tr>-->
					</table>
					<div v-else style="text-align: center;line-height: 70px;font-size: 44px;color:#999">暂无数据</div>
				</div>
			</div>
			<!--table-->
			<div class="details-table-title">
				<img src="../../../static/img/detail-run-icon.png" alt="">
				<span>运行记录</span>
				<!--<el-button type="primary" style="margin-left: 20px" @click="LocalRecord()">查看历史作业位置</el-button>-->
				<div class="block" style="display: inline-block;float: right">
          <div class="swiper_box">
            <div class="swiper-father">
              <div class="swiper-container container_box">
                <div class="swiper-wrapper">
                  <div :class="['swiper-slide',isActiveWorkType==index ? 'active' : '' ]" v-for="(item,index) in yearData" :key="index" @click="typeClick(index,item)">{{item}}年</div>
                </div>
              </div>
            </div>
          </div>
					<div style="display: inline-block;margin-right: 30px;color: #75c3ff">
						<el-checkbox v-model="checkZero" @change="displayZreo" style="color: #409EFF">显示 ‘0亩’</el-checkbox>
						<!--<label for="是否显示 ‘0亩’"></label>-->
						<!--<el-radio v-model="checkZero" label="0" style="color: #fff" @change="displayZreo">是</el-radio>-->
						<!--<el-radio v-model="checkZero" label="1" style="color: #fff" @change="displayZreo">否</el-radio>-->
					</div>
					<span class="demonstration">时间</span>
					<el-date-picker v-model="value2" type="month" placeholder="选择月" value-format="yyyy-MM">
					</el-date-picker>
					<el-button type="primary" @click="onSubmit">查询</el-button>
				</div>
			</div>
			<el-main style="margin-top:25px;padding:0">
				<el-table :data="tableData" style="width: 100%;">
					<el-table-column prop="id" label="序号" width="180" type="index">
					</el-table-column>
					<el-table-column prop="stat_time" label="日期" width="180">
					</el-table-column>
					<el-table-column prop="run_time_day" label="运行时长">
						<template slot-scope="scope">
							<div v-if="scope.row.run_time_day !==''">{{scope.row.run_time_day+'小时'}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="mileage_day" label="运行里程">
						<template slot-scope="scope">
							<div v-if="scope.row.mileage_day !==''">{{scope.row.mileage_day+'公里'}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="predictArea" label="预计作业面积">
						<template slot-scope="scope">
							<div v-if="scope.row.predictArea !==''">{{scope.row.predictArea+'亩'}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="workArea" label="作业地区">
					</el-table-column>
					<el-table-column prop="address" label="操作">
						<template slot-scope="scope">
							<el-button @click="trajectory(scope.row)" type="text" size="small">轨迹查看</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div v-if="nodata" style="text-align: center;line-height: 70px;font-size: 30px;color:#999;width:100%;height: 600px;line-height: 600px">暂无数据</div>
			</el-main>
			<div v-if="isloading" class="">
				<div class="el-loading-spinner"><i class="el-icon-loading"></i>
					<p class="el-loading-text">拼命加载中</p>
				</div>
			</div>
			<div class="blocks">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="checkcurrentPage" layout="total, sizes, prev, pager, next, jumper" :total="total" v-if="tableData&&tableData[0]">
				</el-pagination>
			</div>
		</el-container>
		<div v-show="dialogDetail" class="dialogMapDetail myDialog">
			<div class="dialogWrap">
				<div class="dialogTitle">{{this.dataTitle.njName}}作业信息</div>
				<div class="dialogClose" @click="closeDialog">×</div>
				<div class="dialogMap">
					<div id="mapContainers" class="myMapDialog">
					</div>
					<div class="dialogMapText">
						<table>
							<tr>
								<td>监控编号：{{this.dataTitle.imei}}</td>
								<td>机具型号：{{this.dataTitle.productModel}}</td>
								<td>出厂编号：{{this.dataTitle.factoryCode}}</td>
								<td>作业时间：{{this.dataTitle.operatTime}}</td>
								<td>作业地区：{{this.dataTitle.workArea}}</td>

							</tr>
							<tr>
								<td>时长：{{ runTimeDay }}</td>
								<td>里程：{{this.dataTitle.mileageDay}}公里</td>
								<td>预计面积：{{operatArea}}</td>
								<!--<td>
							<el-checkbox class="showProLinesCheck" v-model="showProLinesCheck" size="small">区县边界</el-checkbox>
						</td>-->
							</tr>
						</table>

					</div>
					<div id="tools">
						<div class="btns">
							<ul class="speedUp" v-show="popVisible">
								<li v-for="(item,index) in speedList" :class="{'speedActive':index==speedIsActive}" @click.stop="handlePlay('accelerate',index)" :key="index">{{item.speedTimes}}</li>
							</ul>
							<dl :class="calendarFlag == true?'img-onlyRead':''" @click.stop="speedChange('slowdown')">
								<dt id="moderatingBtn">
												<img src="/static/bofang/jiansu.png" />
											</dt>
								<dd>减速</dd>
							</dl>

							<dl>
								<dt id="pauseBtn" @click='handlePlay(operationForPauseAndContinueDialog)'>
									<img :src="continueOrStopUrl" id="starImgs"/>
									
								</dt>
								<dd id="pauseBtnsText">开始</dd>
							</dl>

							<dl :class="calendarFlag == true?'img-onlyRead':''" @click.stop="speedChange('accelerate')">
								<dt id="acceleratedBtn">
												<img src="/static/bofang/jiasu.png" />
											</dt>
								<dd>加速</dd>
							</dl>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Gmap from "../../map/js/fzTianmap.js";
	import Api from '../../Serves/net-api.js'
	import Http from '../../Serves/net-http.js'
	import { mapState, mapActions, mapMutations } from "vuex";
	import 'maptalks/dist/maptalks.css'
	import * as maptalks from 'maptalks'
	import TalksMapDialog from '../../map/js/initMapTalks.js'

	export default {
		name: "MonitorDetails",
		components: {},
		computed: {
			...mapState({
				details: state => state.details,
				//      imei:state=>state.imei,
				time: state => state.time,
				handleName: state => state.kName,
			}),

		},

		data() {
			return {
				dialogGamps: new Gmap(),
				isloading: true,
				nodata: false,
				// loading:false,//表格加载状态
				checkZero: false,
				total: 1,
				pageSize: '',
				currentPage: 1,
				checkcurrentPage: 10,
				currentPage1: 5,
				currentPage2: 5,
				currentPage3: 5,
				currentPage4: 4,
				formInline: {
					user: '',
					region: ''
				},
				value: [],
				value2: '',
				tableData: [],
				dialogDetail: false,
				dataTitle: '',
				TalksMapDialog: new TalksMapDialog(),
				runTimeDay: '',
				operatArea: '',
				calendarFlag: true,
				startContinue: "start",
				operationForPauseAndContinueDialog: "start",
				map: "",
				stopedIndex: 0,
				trackList: [],
				zanting: require('/static/bofang/zanting.png'),
				kaishi: require('/static/bofang/start.png'),
				continueOrStopUrl: require('/static/bofang/start.png'),
				tingzhi: require('/static/bofang/tingzhi.png'),
				speedList: [{
					'speedTimes': '0.5X',
					'speed': 800,
				}, {
					'speedTimes': '1X',
					'speed': 400,
				}, {
					'speedTimes': '2X',
					'speed': 200,
				}, {
					'speedTimes': '3X',
					'speed': 133,
				}],
				speedIsActive: 1,
				popVisible: false,
				showProLinesCheck:false,
        njInfoData: {},
        deviceType: '',
        yearData: [],
        isActiveWorkType: 0,
        year: new Date().getFullYear()
			}
		},
		props: ['imei', 'id', 'source', 'sourceId','qrNumber'],
		watch: {
			imei(curVal, oldVal) {
				this.currentPage = 1;
				this.getDetails()
				this.getdata()
        this.getYear()
			},
			handleName(newVal, oldVal) {
				if(newVal == 'end') {
					this.operationForPauseAndContinueDialog = 'start'
					document.getElementById("pauseBtnsText").innerHTML = "开始";
					this.continueOrStopUrl = this.kaishi;
					this.calendarFlag = true;
				}
			},
			showProLinesCheck(newVal, oldVal) {
				if(newVal) {
					this.mapCenter = this.TalksMapDialog.map.getCenter()
					var parmse = {
						lng: this.mapCenter.x,
						lat: this.mapCenter.y
					}
					Api.doPost(Http.gis.getCountyBorderByViewCenter, parmse, false, (res) => {
						this.TalksMapDialog.drawCountyLine(res.result);
					})
				} else {
					this.TalksMapDialog.countyLayer.clear()
				}
			}
		},

		mounted() {
			this.TalksMapDialog.sendThis(this);
			let this_ = this;
			document.addEventListener('click', function(e) {
				if(this_.popVisible === true) {
					this_.popVisible = false
				}
			})
		},

		methods: {
			...mapActions(['getListNjDetails']),
			...mapMutations(['saveTabkeInfo']),
			handleChange(value) {},
      getYear () {
        var dd = new Date()
        var year1 = dd.getFullYear()
        var year2 = dd.getFullYear() - 1
        var year3 = dd.getFullYear() - 2
        var year4 = dd.getFullYear() - 3
        var year5 = dd.getFullYear() - 4
        this.yearData = [year1,year2,year3,year4,year5]
      },
      typeClick(index, item) {
        this.isActiveWorkType = index
        this.year = item
        this.getdata()
      },
			displayZreo() {
        if (this.source === 1) {
          var parmse = {
            startTime: this.value2 == '' ? '' : this.value2,
            imei: this.imei,
            njId: this.sourceId,
            checkZero: this.checkZero === true ? 0 : 1,
            year: this.year,
            currentPage: this.currentPage,
            pageSize: 10
          }
          var url = Http.test + '/purchaseSubsidyMonitor/workRecordList'
        } else {
          var parmse={
            startTime:this.value2==''? '':this.value2,
            imei:this.imei,
            source: this.source,
            year: this.year,
            checkZero:this.checkZero === true ? 0 : 1,
            currentPage:this.currentPage,
            pageSize: 9
          }
          var url=Http.test+'/dtIotNjData/workRecordList'
        }
        this.isloading = true
        this.nodata = false
				Api.doPost(url, parmse, false, (res) => {
          this.isloading = false
					this.tableData = res.result.dataSource
					this.total = res.result.totalRow
					if(this.tableData.length == 0) {
						this.nodata = true
					} else {
						this.nodata = false
					}
				}, (doError) => {})
			},
			onSubmit() {
				this.nodata = false
        this.currentPage = 1
        if (this.source === 1) {
          var parmse = {
            startTime: this.value2 == null ? '' : this.value2,
            checkZero: this.checkZero === true ? 0 : 1,
            imei: this.imei,
            njId: this.sourceId,
            year: this.year,
            currentPage: this.currentPage,
            pageSize: this.checkcurrentPage
          }
          var url = Http.test + '/purchaseSubsidyMonitor/workRecordList'
        } else {
          var parmse={
            startTime:this.value2==null? '':this.value2,
            checkZero:this.checkZero === true ? 0 : 1,
            imei:this.imei,
            source: this.source,
            year: this.year,
            currentPage:this.currentPage,
            pageSize:this.checkcurrentPage
          }
          var url=Http.test+'/dtIotNjData/workRecordList'
        }
        this.isloading = true
				Api.doPost(url, parmse, false, (res) => {
          this.isloading = false
					this.tableData = res.result.dataSource
					this.total = res.result.totalRow
					if(this.tableData.length == 0) {
						this.nodata = true
					} else {
						this.nodata = false
					}
				}, (doError) => {
					console.log(doError)
				})
			},
			// 获取列表数据
			getdata() {
        if (this.source === 1) {
          var parmse = {
            imei: this.imei,
            njId: this.sourceId,
            currentPage: this.currentPage,
            pageSize: this.checkcurrentPage,
            year: this.year,
            checkZero: this.checkZero === true ? 0 : 1
          }
          var url = Http.test + '/purchaseSubsidyMonitor/workRecordList'
        } else {
          var parmse={
            imei:this.imei,
            source: this.source,
            currentPage:this.currentPage,
            pageSize:this.checkcurrentPage,
            year: this.year,
            checkZero:this.checkZero === true ? 0 : 1
          }
          var url=Http.test+'/dtIotNjData/workRecordList'
        }
        this.isloading = true
        this.nodata = false
				Api.doPost(url, parmse, false, (res) => {
					this.isloading = false
					this.tableData = res.result.dataSource
					this.total = res.result.totalRow
					if(this.tableData.length == 0) {
						this.nodata = true
					} else {
						this.nodata = false
					}
				}, (doError) => {
					console.log(doError)
				})
			},
			// 获取参数数据
			getDetails() {
        if (this.source === 1) {
          var parmse = {
            // imei: this.imei,
            qrNumber: this.qrNumber,
            njId: this.sourceId
          }
          this.getListNjDetails(parmse);
        } else {
          var parmse={
            source: this.source,
            sourceId: this.sourceId
          }
          var url=Http.test+'/dtIotNjData/findById'
          Api.doPost(url,parmse,false,(res)=>{
            this.njInfoData = res.result
          },(doError)=>{
            console.log(doError)
          })
        }
			},
			//  显示条数控制
			handleSizeChange(val) {
				this.checkcurrentPage = val
        this.currentPage = 1
        if (this.source === 1) {
          var parmse = {
            startTime: this.value2 == null ? '' : this.value2,
            imei: this.imei,
            njId: this.sourceId,
            year: this.year,
            currentPage: this.currentPage,
            checkZero: this.checkZero === true ? 0 : 1,
            pageSize: val
          }
          var url = Http.test + '/purchaseSubsidyMonitor/workRecordList'
        } else {
          var parmse={
            startTime:this.value2==null? '':this.value2,
            imei:this.imei,
            source: this.source,
            year: this.year,
            currentPage:this.currentPage,
            pageSize:val,
            checkZero:this.checkZero === true ? 0 : 1,
          }
          var url=Http.test+'/dtIotNjData/workRecordList'
        }
        this.isloading = true
				Api.doPost(url, parmse, false, (res) => {
          this.isloading = false
					this.tableData = res.result.dataSource
					this.total = res.result.totalRow
				}, (doError) => {
					console.log(doError)
				})
			},
			//分页
			handleCurrentChange(currentPage) {
        // this.currentPage=currentPage;
        if (this.source === 1) {
          var parmse = {
            startTime: this.value2 == null ? '' : this.value2,
            imei: this.imei,
            njId: this.sourceId,
            currentPage: currentPage,
            year: this.year,
            checkZero: this.checkZero === true ? 0 : 1,
            pageSize: this.checkcurrentPage
          }
          var url = Http.test + '/purchaseSubsidyMonitor/workRecordList'
        } else {
          var parmse={
            startTime:this.value2==null? '':this.value2,
            imei:this.imei,
            source: this.source,
            currentPage:currentPage,
            year: this.year,
            checkZero:this.checkZero === true ? 0 : 1,
            pageSize:this.checkcurrentPage
          }
          var url=Http.test+'/dtIotNjData/workRecordList'
        }
        this.isloading = true
				Api.doPost(url, parmse, false, (res) => {
          this.isloading = false
					this.tableData = res.result.dataSource
					this.currentPage = currentPage
				}, (doError) => {
					console.log(doError)
				})
			},
			todaytrajectory(imei) {
				var imei = this.imei; //更改过后
				var data = {
					imei: imei,
					stat_time: row.stat_time,
				}
				this.$router.push({
					name: 'RecordItem',
					params: data
				})
				this.$store.commit('time', {
					"time": row.stat_time
				})
			},
			trajectory(row) {
				let this_ = this;
				var aa = {
					startTime: this.value2 == null ? '' : this.value2,
					imei: this.imei,
          qrNumber: row.qrNumber,
					currentPage: this.currentPage,
					// checkZero:this.checkZero,
					pageSize: this.checkcurrentPage
				}
				sessionStorage.setItem('manageParam', JSON.stringify(aa))
				var imei = this.imei; //更改过后
				var data = {
					imei: imei,
					stat_time: row.stat_time
				}
				this.collectTime = row.stat_time;
				this.deviceType =  row.deviceType
				this.dialogDetail = true
				let that = this
				this.$nextTick(function() {
					if(!that.TalksMapDialog.map) {
						this.TalksMapDialog.init("mapContainers", 18);
					}
					that.getCenterPos(row.qrNumber)

				})
				//				this.$router.push({
				//					name: 'RecordItem',
				//					params: data
				//				})

				this.$store.commit('time', {
					"time": row.stat_time
				})
			},

			//			获取轨迹数据
			trackViewing(qrNumber) {
        let this_ = this;
        var url = ''
        if (this.source == 1) {
          var parmse = {
            imei: this.imei,
			      deviceType: this.deviceType?this.deviceType:undefined,
            startTime: this.collectTime,
            source: this.source,
            qrNumber: qrNumber
          }
          url = Http.test + "/purchaseSubsidyMonitor/findTrack"
        } else {
          var parmse = {
            imei: this.imei,
			      deviceType: this.deviceType?this.deviceType:undefined,
            startTime: this.collectTime,
            source: this.source
          }
          url = Http.test + "/track/findTrack"
        }
				Api.doPost(url, parmse, false, (res) => {
					var List = res.result.list
					this.trackList = res.result.list
					this.dataTitle = res.result
					this.runTimeDay = res.result.runTimeDay === '' ? '' : res.result.runTimeDay + '时'
					this.operatArea = res.result.operatArea === '' ? '' : res.result.operatArea + '亩'
					this.lineArr = List
					if(this_.lngLatCenter) {
						this_.TalksMapDialog.map.setCenter(this_.lngLatCenter)
					} else {
						let Coordinate = {
							x: Number(List[0].lng),
							y: Number(List[0].lat)
						}
						this_.TalksMapDialog.map.setCenter(Coordinate)
					}
					this_.TalksMapDialog.drawLine(List);
					this.TalksMapDialog.carPoint.clear()
				})
			},
			getCenterPos(qrNumber) {
				var parmse = {
					imei: this.imei,
					sendDate: this.collectTime
				}
				Api.doPost(Http.gis.findBlocks, parmse, false, (res) => {
					if(res && res.result && res.result.lng) {
						this.lngLatCenter = {
							x: Number(res.result.lng),
							y: Number(res.result.lat)
						}

					} else {
						this.lngLatCenter = ''
					}
					this.trackViewing(qrNumber)

				})
			},
			closeDialog() {

				this.dialogDetail = false
				this.trackList = []
				//				if(this.TalksMapDialog.map) {
				//					this.TalksMapDialog.map.clearOverLays();
				//				}
				if(this.TalksMapDialog._timer || this.TalksMapDialog.i > 0) {
					clearInterval(this.TalksMapDialog._timer);
					this.TalksMapDialog.i = 0
					this.TalksMapDialog._timer = ''
				}
				this.TalksMapDialog.lastLineLayer.clear()
				this.TalksMapDialog.carPoint.clear()
				this.TalksMapDialog.fist = true
				this.TalksMapDialog.lineLog = []
				this.TalksMapDialog.lastLinePoints = []

				this.operationForPauseAndContinueDialog = 'start'
				if(this.TalksMapDialog.btnName) {
					this.dialogGamps.btnName = ''
				}

				document.getElementById("pauseBtnsText").innerHTML = "开始";
				this.continueOrStopUrl = this.kaishi;
				this.calendarFlag = true
			},
			speedChange(typeName) {
				if(this.popVisible) {
					if(typeName == 'slowdown') {
						this.speedIsActive = this.speedIsActive == 0 ? 0 : this.speedIsActive - 1
					} else {
						let len = this.speedList.length - 1;
						this.speedIsActive = this.speedIsActive == len ? len : this.speedIsActive + 1
					}
					this.speedNum = this.speedList[this.speedIsActive].speed;
					if(this.trackList.length > 0) {
						this.TalksMapDialog.playBack(
							this.trackList,
							typeName,
							this.stopedIndex,
							this.stopedIndex > 0,
							undefined, this.speedNum
						);
					}
				} else {
					this.popVisible = true
				}

			},
			handlePlay(typeName, index) {
				if(index || index === 0) {
					this.speedNum = this.speedList[index].speed
				}
				if (document.getElementById('pauseBtnsText').innerHTML === '开始') {
					typeName = 'start'
				}
				if(typeName === "start") { //开始
					let name_ = this.$store.state.kName
					this.$store.state.kName = name_ ? '' : 'start'
					//					this.clearPolyline();
					this.stopedIndex = 0;
					this.calendarFlag = false;
					this.operationForPauseAndContinueDialog = 'pause'
					document.getElementById("pauseBtnsText").innerHTML = "停止";
					document.getElementById('starImgs').src = require('../../../static/bofang/tingzhi.png')
					this.continueOrStopUrl = this.tingzhi;
					this.speedNum = 400
					this.speedIsActive = 1
				} else if(typeName === "pause") {
					this.stopedIndex = this.TalksMapDialog.i;
					this.operationForPauseAndContinueDialog = 'continue'
					document.getElementById("pauseBtnsText").innerHTML = "继续";
					this.continueOrStopUrl = this.kaishi;
					this.calendarFlag = true;
					this.popVisible = false;
				} else if(typeName === "continue") {
					this.operationForPauseAndContinueDialog = 'pause'
					document.getElementById("pauseBtnsText").innerHTML = "停止";
					this.continueOrStopUrl = this.tingzhi;
					this.calendarFlag = false;
				} else if(typeName === "stop") {
					this.TalksMapDialog.lastLinePoints = []
					this.calendarFlag = true;
					this.popVisible = false;
				} else if(typeName === "accelerate") { //加速减速
					this.speedIsActive = index
					this.speedNum = this.speedList[index].speed;
				}
				if(this.trackList.length > 0) {
					this.TalksMapDialog.playBack(
						this.trackList,
						typeName,
						this.stopedIndex,
						this.stopedIndex > 0,
						undefined, this.speedNum
					);
				}
			},

			clearPolyline() {
				this.TalksMapDialog.newLineLayer.clear()
				this.TalksMapDialog.lastLineLayer.clear()
				this.TalksMapDialog.carPoint.clear()
			},
			tadayRecord() { //今日轨迹
				var imei = this.imei;
				var data = {
					imei: this.imei,
					startTime: this.getNowFormatDates()
				}
				localStorage.setItem('imei', this.imei)
				localStorage.setItem('startTime', this.getNowFormatDates())
				this.$router.push({
					name: 'TodayRecordItem',
					params: data
				})
			},
			//历史作业轨迹
			LocalRecord() {
				var imei = this.imei //更改
				this.$router.push({
					name: 'LocalRecord',
					params: {
						imei: imei
					}
				})
			},
			// 获取去年当前月
			getNowFormatDates() {
				var date = new Date();
				var seperator1 = "-";
				var year = date.getFullYear();
				var month = date.getMonth() + 1;
				var strDate = date.getDate();
				if(month >= 1 && month <= 9) {
					month = "0" + month;
				}
				if(strDate >= 0 && strDate <= 9) {
					strDate = "0" + strDate;
				}
				var currentdate = year + seperator1 + month + seperator1 + strDate
				return currentdate;
			}
		}
	}
</script>

<style scoped>
	td {
		/* overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis !important; */
		word-break: break-all;
  		white-space: nowrap;
	}
	.blocks{
    width: 100%;
    margin-top: 1.5vh;
    margin-bottom: 1vh;
		display: -webkit-box;
		-webkit-box-align: center;
		-webkit-box-pack: center;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.el-header {
		height: 0px !important;
	}
	
	.el-table {
		width: 98% !important;
		margin: auto;
		color: #fff;
	}
	
	.details-parameter-tit {
		width: 95% !important;
		margin: auto;
		height: 40px;
		line-height: 40px;
	}
	
	.details-parameter-tit i:nth-child(1) {
		font-size: 22px;
		font-weight: bold;
		color: #75c3ff;
	}
	
	.details-parameter-tit i:nth-child(1):hover {
		font-size: 22px;
		font-weight: bold;
		color: #297af5;
		cursor: pointer;
	}
	
	.details-parameter-tit i:nth-child(2) {
		display: inline-block;
		width: 5px;
		height: 20px;
		position: relative;
		top: 3px;
		background-color: #297af5
	}
	
	.myDetail span {
		display: block;
		font-weight: bold;
		color: #fff;
		font-size: 1.2vw;
		text-align: center;
		margin-top: 2vh;
	}
	
	.details-ret {
		display: inline-block;
		margin-left: 20px;
		cursor: pointer;
		float: none !important;
		position: unset !important;
	}
	
	.details-ret span {
		display: inline-block;
		margin-left: 5px;
		font-size: 14px;
		font-weight: unset;
		color: #f45a2b;
	}
	
	.details-parameter {
		/*width: 95% !important;*/
		/*width: 1900px;*/
		margin: 10px 0 1vh 1vw;
	}
	
	.details-parameter-left {
		float: left;
		width: 65%;
		height: 17.5vh;
    background: url("../../../static/img/details_bg.png" ) no-repeat;
    background-size:100% 100%;
    padding: 1vw;
    box-sizing: border-box;
    display: inline-block;
    position: relative;
    margin-right: 1vw;
    /* margin-bottom: 1vw; */
	}
	
	.parameter-njxx{
    height: 2.7vh;
    line-height: 2.7vh;
    font-size: 0.83vw;
    color: #fff;
    width: 40%;
    float: left;
    /*display: inline-block;*/
  }
  .parameter-njxx img{
    width: 1vw;
    height: 1.5vh;
    position: relative;
  }
	
	.parameter-table {
		width: 80%;
		display: inline-block;
	}
	
	.parameter-table tr td {
    padding: 5px 10px;
    font-size: 0.8vw;
	}
	
	.parameter-table tr td:nth-child(odd) {
		/*width: 15%;*/
		text-align: right;
		color: #75c3ff;
	}
	
	.parameter-table tr td:nth-child(even) {
		padding-left: 0;
		color: #bad1ef;
		/*min-width: 150px;*/
	}
	
	.details-parameter-ewm{
    float: right;
    display: inline-block;
    margin-right: 10px;
    position: absolute;
    top:30px;
    right:10px;
    /*margin-top: -30px;*/
  }
	/*.details-parameter-ewm img{*/
	/*margin: 5px*/
	/*}*/
	
	.details-parameter-right {
		width: 33%;
		/*min-width: 480px;*/
		height: 17.5vh;
		display: inline-block;
		box-sizing: border-box;
		background: url("../../../static/img/details_bg2.png") no-repeat;
		background-size: 100% 100%;
	}
	
	.details-parameter-right p {
		font-size: 0.833vw;
	}
	
	.details-running{
    margin-top: 0.5vw;
    margin-left: 1vh;
    min-width: 80%;
  }
  .details-running tr{
    min-width: 100%;
  }
  .details-running tr td:nth-child(odd) {
    text-align: right;
    padding : 5px 10px 5px 0;
    color: #75c3ff;
  }
  .details-running tr td:nth-child(even) {
    color: #bad1ef;
  }
	
	.details-table-title{
    width: 98%;
    margin: auto;
    /* margin-top: 10px; */
    font-size: 0.83vw;
    color: #fff;
  }
  .details-table-title img{
    width: 1vw;
    height: 2vh;
    position: relative;
    top:5px
  }
	
	.demonstration {
		font-size: 14px !important;
		color: #75c3ff !important;
	}
  .swiper-slide {
    width: 72px!important;
    height: 40px;
    text-align: center;
    cursor: pointer;
    word-break: break-all;
    justify-content: center;
    align-items: center;
    display: flex;
    padding: 0 10px;
    /* line-height: 40px; */
    background: #273488;
    margin-right: 10px;
  }
  .active{
    background: #0b50e8;
    color: #ffffff;
  }
  .swiper_box{
    width: 460px;
    float: left;
    margin-right: 20px;
  }
  .swiper_content{
    width: 100%;
    height: 50px;
  }
  .swiper-wrapper{
    width: 100%;
    display: flex;
  }
  .swiper-father{
    width: 100%;
    height: 40px;
    margin: 0 auto;
    position: relative;
  }
  .swiper-container{
    width: 460px;
    margin: 0 auto;
  }
  .container_box{
    margin-left: 0!important;
  }
  .swiper-button-prev:after, .swiper-container-rtl .swiper-button-next:after{
    font-size: 22px;
  }
  .swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after{
    font-size: 22px;
  }
  .swiper-button-prev, .swiper-container-rtl .swiper-button-next{
    background: #cccccc;
    color: rgba(0, 0, 0, 0.65);
    left: 0;
  }
  .swiper-button-next, .swiper-container-rtl .swiper-button-prev{
    background: #cccccc;
    color: rgba(0, 0, 0, 0.65);
    right: 0;
  }
  .swiper-button-next, .swiper-button-prev{
    cursor: pointer;
    z-index: 10;
    position: absolute;
  }
	
	@media screen and (max-width:1630px) {
		/* .parameter-table tr td[data-v-52f42fc4]:nth-child(even) {
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			max-width: 100px;
		} */
		/*.details-parameter {*/
		/*!*display:none;*!*/
		/*}*/
		/*.details-parameter-left {*/
		/*width: 920px;*/
		/*}*/
		/*.details-running{*/
		/*width: 95%;}*/
		/*.details-parameter-right{*/
		/*width: 55%;*/
		/*}*/
	}
	/*.el-checkbox__inner{*/
	/*background-color:#409EFF !important ;*/
	/*}*/
</style>


// WEBPACK FOOTER //
// src/components/TableList/DiscountDetailsDialog.vue